import { api } from '@/f1/service';
import codes from '@/f1/codes';
import Language from './language';

//restful api
//import { wmds as ws } from '@/f1/service/api'

//i18n_data
import _i18n_data from './i18n_data'
import i18n_data from '@/component/i18n_data';

export default {
  components: { Language },
  data: () => {
    return {
      confirm: undefined,
      selected: undefined,
      show: true,
      group : {},
      start : false,
      so : Object.assign({}, codes.DEFAULT_OPT, { opt : {} }),
    }
  },
  computed: {
    fields (){ return _i18n_data.i18n_fields[this.i18n]},
    rowCount() { return this.so.totalRows || 0; },
    startRow () { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
  },
  methods: {
    action(cmd = 'start', item) {
      switch (cmd) {
        case 'result':
          this.$router.push({ name: 'wmds_result', params: { site_id : item.site_id }});
          this.$emit('refresh')
          break;
        case 'site':
          this.$router.push({ name: 'wmds_site', params: { id : item.site_id }});
          this.$emit('refresh')
          break;
        case 'delay':
        case 'start':
          item.is_starting = true
          api.wmds.WMDS({ target : 'schedule', cmd : cmd, body : { site_id : item.site_id } }).then(rs => {
          //Todo : response 하는 값은 동일. 그렇다면 요청을 한 api 로만 해도 되는것이 아닌가?
          // 기존 api 가 cmd 별로 나누어져있는지 확인이 필요
          // cmd : start
          //ws.schedule.start({ site_id : item.site_id }).then(rs => {
          // cmd : delay
          //ws.schedule.delay({ site_id : item.site_id }).then(rs => {
            rs.error ? this.$toastr.w(`${i18n_data._i18n_error.failed[this.i18n]}`, `${_i18n_data._i18n_warning.failed_custom[this.i18n]}`, cmd, ` ${i18n_data._i18n_error.failed[this.i18n]}`) : this.$toastr.s(`${i18n_data._i18n_success.done[this.i18n]}`, `${_i18n_data._i18n_success.done[this.i18n]}`, cmd)
          }).then(() => this.refresh()).catch(e => { this.$toastr.e(e.data ? e.data.message : e) })
          break;
      }
    },
    reset() { this.so = Object.assign({}, codes.DEFAULT_OPT, { opt : {} }); this.$refs._list.refresh();},
    refresh() { this.$refs._list.refresh(); },
    getItems(ctx) { return this.load(ctx); },
    remove() {
      try{
        api.wmds.WMDS_Call('schedule', 'delete', { id : this.selected.id })
        //ws.schedule.delete({ id : this.selected.id })
        this.refresh(); this.$toastr.i(`${_i18n_data._i18n_info.remove_schedule[this.i18n]}`);
      } catch(e) { this.$toastr.e(e.data ? `${i18n_data._i18n_error.remove_failed[this.i18n]}` : e.data.message ? e.data.message : e.statusText)  }
    },
    load(ctx = {}) {
      let so = {
        target : 'schedule', cmd : 'list',
        body : { sort : [ { name : 'id', op : 'desc' } ], or : [], and : [] },
        offset : (this.so.currentPage-1 || 0) * 10, limit: 10, // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : ctx.sortDesc && 'desc' } ]; }
      if((this.so.sv || '').trim() && this.so.sk) { so.body.and = [ { name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' } ] }
      return api.wmds.WMDS(so).then(rs => {
      //return ws.schedule.list(so).then(rs => {
        if(rs.error) { return this.$$toastr.e(`${_i18n_data._i18n_error.load_failed[this.i18n]}`) }
        this.so.totalRows = rs.total;
        (rs.body || []).forEach(r => r.is_starting = false);
        return rs.body;
      }).catch(e => this.$toastr.e(e.data ? `${i18n_data._i18n_error.load_failed[this.i18n]}` :  e.data.message ? e.data.message : e.statusText) );
    },
    hideList(e) { this.show = !e; console.log('schedule.list.vue', 'got event (list show/hide)', !e ? 'show' : 'hide') }
  },
  created() { console.log('schedule.list.vue', 'created'); },
  destroyed() { console.log('schedule.list.vue', 'destroyed'); },
  mounted() {
    console.log('schedule.list.vue', 'mounted');
    try { this.start = location.hostname == "localhost" || location.hostname == "console.f1secaas.co.kr"; } catch { this.start = false; }
  },
}
